import {LitElement, html} from 'lit';
import {customElement, property} from 'lit/decorators.js';
import {unsafeHTML} from 'lit/directives/unsafe-html.js';
import {getLocallangText} from '../../swsRateCalculatorForm-init.mjs';

interface Tariff {
    title: string;
    title_long: string;
    media: string;
    zips: number[];
    icon: string;
    description_short: string;
    description: string;
    description_long: string;
    labor_price: number;
    base_price: any[];
    type: number;
    faqs: {
        title: string;
        answer: string;
    }[];
}

@customElement('sws-tariff-details')
export class SwsTariffDetails extends LitElement {
    @property({type: Object}) tariff?: Tariff;

    @property({type: Array})
    tariffs: Tariff[] = [];

    @property({type: Number}) activeCategory: number = 2;

    public setActiveTariffByTitle(title: string) {
        const found = this.tariffs.find(t => t.title === title);
        if (found) {
            this.tariff = found;
        }
    }

    updated(changedProps: Map<string, unknown>) {
        if (changedProps.has('tariffs')) {
            if (!this.tariff || !this.tariffs.includes(this.tariff)) {
                this.tariff = this.tariffs[0]; // neuen Default setzen
            }
        }
    }

    private _handleTariffSelected(e: Event) {
        e.preventDefault();

        this.dispatchEvent(new CustomEvent('tariff-selected', {
            detail: this.tariff, // oder gezielt nur relevante Daten
            bubbles: true,
            composed: true
        }));
    }

    protected render() {

        if (!this.tariff) {
            return html`${TYPO3?.lang?.["form.chooseTariff.benefit.noTariff"]}`;
        }

        return html`
            <div class="bg-white p-3-75">
                <div id="product-container" class="sws-available-tariffs">
                    <ul class="nav nav-pills mb-3">
                        ${this.tariffs.length > 1 ? html`
                            ${this.tariffs.map(
                                    category => html`
                                        <li class="nav-item">
                                            <button
                                                    class="nav-link btn-toggle-bg font-18 py-3 px-4 mb-3 ${this.tariff === category ? 'active' : ''}"
                                                    @click="${() => (this.tariff = category)}"
                                                    aria-label="${getLocallangText("form.chooseTariff.details.ariaLabel", [category.title])}"
                                            >
                                                ${category.title}
                                            </button>
                                        </li>
                                    `
                            )}
                        ` : html``}
                    </ul>
                </div>

                <div class="tab-pane fade show active" id="tab-green-electricity-12" role="tabpanel"
                     aria-labelledby="tab-green-electricity-12">
                    <div class="row">
                        <!-- Video (links auf Desktop, unten auf Mobile) -->
                        <div class="col-lg-5 order-lg-1 order-2 mb-4 mb-lg-0 rounded-sm">
                            <div class="h-auto media-box">
                                ${unsafeHTML(this.tariff.media)}
                            </div>
                        </div>

                        <!-- Text (rechts auf Desktop, oben auf Mobile) -->

                        <h3 class="fw-bold pt-4 mb-5">${this.tariff.title_long}</h3>
                        <div class="col-lg-7 order-lg-2 order-1 tariff-description-long">
                            ${unsafeHTML(this.tariff.description)}

                            <h5 class="mt-4 fw-bold">${this.tariff.title}
                                ${TYPO3?.lang?.["form.chooseTariff.details.inOverview"]}</h5>
                            <div class="tariff-description text-start">
                                ${unsafeHTML(this.tariff.description_short)}
                            </div>

                            <a href="#"
                               class="btn btn-primary w-auto w-md-50 d-flex align-items-center justify-content-center text-white mb-5 px-4"
                               @click="${this._handleTariffSelected}"
                               aria-label="${getLocallangText("btn.chooseTariff.ariaLabel", [this.tariff.title])}">
                                ${getLocallangText("form.chooseTariff.details.chooseTariff", [this.tariff.title])}
                            </a>

                        </div>
                    </div>

                    <div class="row justify-content-center">
                        <div class="accordion accordion-flush" id="accordionFlushExample1">
                            ${this.tariff.faqs.map((faq, index) => html`
                                <div class="accordion-item">
                                    <h2 class="accordion-header" id="heading-${index}">
                                        <button
                                                class="accordion-button collapsed bg-white"
                                                type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target="#collapse-${index}"
                                                aria-expanded="false"
                                                aria-controls="collapse-${index}">
                                            <i class="icon-arrow-right icon-arrow-accordion rotate-icon"></i>
                                            <p class="p-3 ps-4 pt-4 font-18 fw-bold m-0">${faq.title}</p>
                                        </button>
                                    </h2>
                                    <div
                                            id="collapse-${index}"
                                            class="accordion-collapse collapse bg-white"
                                            aria-labelledby="heading-${index}"
                                            data-bs-parent="#accordionFlushExample1">
                                        <div class="accordion-body pt-0 font-18">
                                            ${unsafeHTML(faq.answer)}
                                        </div>
                                    </div>
                                </div>
                            `)}
                        </div>
                    </div>

                </div>
            </div>
        `;
    }

    createRenderRoot() {
        return this;
    }
}
